import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { TableReload } from '#app/Action/TableAction';
import { dispatch } from '#app/App';
import ContentViewComponent from '#app/Component/ContentViewComponent';
import TabsComponent from '#app/Component/TabsComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import DisputeList from '#app/View/Sale/OrderClient/SaleOrderClient/components/DisputeList';
import DocumentList from '#app/View/Sale/OrderClient/SaleOrderClient/components/DocumentList';
import History from '#app/View/Sale/OrderClient/SaleOrderClient/components/History';
import ProductList from '#app/View/Sale/OrderClient/SaleOrderClient/components/ProductList';
import Information from '#app/View/Shop/Sale/OrderClient/components/Information';
import { Order } from '#app/typings/order';

const OrderClient: React.FC = () => {
  const params = useParams<{ uuid: string }>();

  const [loading, setLoading] = useState<boolean>(false);
  const [order, setOrder] = useState<Order>();

  useEffect(() => {
    setLoading(true);

    ApiHandler.get<Order>(
      {
        route: 'api_sale_order_client',
        params: { uuid: params.uuid as string },
      },
      (response) => {
        if (response.status === 200) {
          setOrder(response.data);
          setTimeout(() => {
            dispatch(TableReload('api_sale_order_client_litige'));
          }, 100);
        } else {
          dispatch(
            SnackbarOpen({
              text: response?.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }

        setLoading(false);
      },
    );
  }, [params.uuid]);

  return (
    <ContentViewComponent
      loading={loading}
      breadcrumbs={{
        title: 'Visualisation de la commande',
        context: 'Vente',
      }}
    >
      {order && (
        <>
          <Grid container spacing={1}>
            <Information order={order} />
            <History history={order.history} />
          </Grid>

          <br />

          <TabsComponent
            tabDefault="sale_order_client"
            tabs={[
              { key: 'sale_order_client', label: 'Articles' },
              { key: 'sale_order_client_litige', label: 'Litiges' },
              { key: 'sale_order_client_document', label: 'Documents' },
            ]}
          >
            <ProductList key="sale_order_client" products={order?.byProducts} loading={loading} />
            <DisputeList key="sale_order_client" products={order?.byProducts} />
            <DocumentList key="sale_order_client_document" />
          </TabsComponent>
        </>
      )}
    </ContentViewComponent>
  );
};

export default OrderClient;
